import * as yup from "yup";

import type { UpdatePractice } from "@elation/api-client/src/stitch-web/models";

import type { YupSchemaValue } from "@src/shared/utils/yup";

export const PracticeInfoFormValidationSchema = yup.object({
  name: yup.string().trim().required("Practice name is required"),
  addressLine1: yup.string().trim().required("Address is required"),
  addressLine2: yup.string().default(""),
  city: yup.string().trim().required("City is required"),
  state: yup
    .string()
    .trim()
    .matches(/^[A-Za-z]{2}$/, "State must be a 2-letter abbreviation")
    .required("State is required"),
  zip: yup.string().trim().required("ZIP is required"),
});

export type PracticeInfoFormValues = YupSchemaValue<
  typeof PracticeInfoFormValidationSchema
>;

export const PracticeInfoUpdatePayloadSchema = yup
  .object({
    name: yup.string().trim().required(),
    addressLine1: yup.string().trim().required(),
    addressLine2: yup
      .string()
      .trim()
      .nullable(true)
      .transform((value) => value || null),
    city: yup.string().trim().required(),
    state: yup.string().trim().required(),
    zip: yup.string().trim().required(),
  })
  .default(undefined) as yup.Schema<UpdatePractice>;
